import { toast, Renderable, ToastOptions } from 'react-hot-toast';

type ToastType = 'info' | 'success' | 'error' | 'loading';

const showToast = (message: string, type: ToastType, icon?: Renderable) => {
  const options: ToastOptions = {
    duration: 3000,
    position: 'top-center',
    icon,
    ariaProps: {
      role: 'status',
      'aria-live': 'polite',
    },
    removeDelay: 1000,
  };

  switch (type) {
    case 'success':
      return toast.success(message, options);
    case 'error':
      return toast.error(message, options);
    case 'loading':
      return toast.loading(message, options);
    case 'info':
    default:
      return toast(message, options);
  }
};

export default showToast;
